<template>
  <footer class="mudra-footer premium-footer">
    <p class="copyright">© 2026 Mudra Token. All rights reserved.</p>

    <p class="disclaimer">
      Mudra Token is a utility reward platform for creators. No investment, no profit guarantee, no financial returns.
    </p>

    <!-- 🔗 Social Media Icons -->
    <div class="social-icons">
      <a
        href="https://www.facebook.com/share/1GD5FF6tva/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
      >
        <i class="fab fa-facebook-f"></i>
      </a>

      <a
        href="https://x.com/Mudra_token"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Twitter / X"
      >
        <i class="fab fa-x-twitter"></i>
      </a>

      <a
        href="https://www.instagram.com/mudratoken_official?igsh=MWN3NnlncTJodHRzaA=="
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
      >
        <i class="fab fa-instagram"></i>
      </a>

      <a
        href="https://whatsapp.com/channel/0029VbB4MMtEquiLJhto0z40"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
      >
        <i class="fab fa-whatsapp"></i>
      </a>

      <a
        href="https://t.me/+BczKd5Qi_ikyOTk1"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Telegram"
      >
        <i class="fab fa-telegram"></i>
      </a>
    </div>

    <!-- Footer Links -->
    <nav class="footer-links" role="navigation" aria-label="Footer navigation">
      <router-link to="/about">About</router-link>
      <router-link to="/whitepaper">Whitepaper</router-link>
      <router-link to="/privacy">Privacy</router-link>
      <router-link to="/terms">Terms</router-link>
    </nav>

    <!-- 📲 Install App -->
    <div v-if="showInstall" class="install-box" @click="installApp">
      📲 Install Mudra App
    </div>
  </footer>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const showInstall = ref(false);
const deferredPrompt = ref(null);

onMounted(() => {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt.value = e;
    showInstall.value = true;
  });

  window.addEventListener("appinstalled", () => {
    showInstall.value = false;
  });
});

const installApp = async () => {
  if (!deferredPrompt.value) return;
  deferredPrompt.value.prompt();
  await deferredPrompt.value.userChoice;
  deferredPrompt.value = null;
  showInstall.value = false;
};
</script>

<style scoped>
/* ───── Premium Footer ───── */
.premium-footer {
  background: rgba(5, 10, 20, 0.98);
  border-top: 1px solid rgba(0, 200, 255, 0.25);
  padding: 24px 16px;
  text-align: center;
  color: #ffffff;
  font-size: 13px;
  font-family: "Inter", sans-serif;
  position: relative;
  z-index: 10;
}

/* Copyright & Disclaimer */
.copyright {
  margin-bottom: 10px;
  font-weight: 600;
  color: #ffffff;
}

.disclaimer {
  margin-bottom: 18px;
  font-size: 12px;
  color: #ffffff;
  opacity: 0.9;
  line-height: 1.5;
}

/* Social Icons */
.social-icons {
  display: flex;
  justify-content: center;
  gap: 18px;
  margin-bottom: 20px;
}

.social-icons a {
  width: 38px;
  height: 38px;
  background: rgba(0, 200, 255, 0.12);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00c8ff;
  font-size: 17px;
  transition: all 0.3s ease;
}

.social-icons a:hover {
  background: linear-gradient(135deg, #00c8ff, #007bff);
  color: #ffffff;
  transform: translateY(-4px);
  box-shadow: 0 6px 20px rgba(0, 200, 255, 0.35);
}

/* Footer Links */
.footer-links {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.footer-links a {
  color: #00c8ff;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
}

.footer-links a:hover {
  color: #80f0ff;
  text-decoration: underline;
  text-shadow: 0 0 6px rgba(0, 200, 255, 0.4);
}

/* Install Box */
.install-box {
  display: inline-block;
  background: linear-gradient(135deg, #00c8ff, #007bff);
  color: #000;
  padding: 10px 20px;
  border-radius: 24px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.install-box:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 200, 255, 0.4);
}

/* Mobile */
@media (max-width: 768px) {
  .premium-footer {
    padding-bottom: 100px; /* extra space for mobile nav */
  }

  .social-icons {
    gap: 14px;
  }

  .footer-links {
    gap: 14px;
  }
}
</style>